export default __webpack_public_path__ + "images/acp-avatar-empty-26aefc.png";